export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    yearsHeader = [],
    groups = [],
    totalPages = "1",
    openingDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let rowsHtml = "";
  groups.forEach((group, gIdx) => {
    // Group Header
    rowsHtml += `
      <tr bgcolor="#F9F9F9" style="font-weight: bold;">
        <td class="border text-center">${gIdx + 1}</td>
        <td class="border" colspan="${3 + yearsHeader.length}" style="padding-left: 8px;">${group.jointVentureName}</td>
      </tr>
    `;

    // Items
    (group.items || []).forEach((item) => {
      let allocationsHtml = "";
      (item.yearlyAllocations || []).forEach((val) => {
        allocationsHtml += `<td class="border text-right px-1">${fmt(val)}</td>`;
      });

      rowsHtml += `
        <tr>
          <td class="border text-center">${item.stt || ""}</td>
          <td class="border px-1">${item.content || ""}</td>
          <td class="border text-right px-1">${fmt(item.totalDifference)}</td>
          <td class="border text-center">${item.allocationPeriod || ""}</td>
          ${allocationsHtml}
        </tr>
      `;
    });

    // Group Footer
    let groupTotalsHtml = "";
    (group.yearlyTotals || []).forEach((total) => {
      groupTotalsHtml += `<td class="border text-right px-1">${fmt(total)}</td>`;
    });

    rowsHtml += `
      <tr bgcolor="#FDFDFD" style="font-weight: bold; font-style: italic;">
        <td class="border"></td>
        <td class="border px-1">Cộng số phân bổ hàng năm</td>
        <td class="border"></td>
        <td class="border"></td>
        ${groupTotalsHtml}
      </tr>
    `;
  });

  let yearsHeaderHtml = "";
  yearsHeader.forEach((year) => {
    yearsHeaderHtml += `<th class="border">${year}</th>`;
  });

  let yearsIndexHtml = "";
  yearsHeader.forEach((_, idx) => {
    yearsIndexHtml += `<th class="border">${idx + 3}</th>`;
  });

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S42a-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 30px 0;">
        <h3 style="margin: 0; text-transform: uppercase;">SỔ THEO DÕI PHÂN BỔ CÁC KHOẢN CHÊNH LỆCH PHÁT SINH KHI MUA KHOẢN ĐẦU TƯ VÀO CÔNG TY LIÊN DOANH</h3>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="40">STT</th>
            <th class="border" rowspan="2">Nội dung phân bổ</th>
            <th class="border" rowspan="2" width="100">Tổng số chênh lệch (1)</th>
            <th class="border" rowspan="2" width="100">Thời gian khấu hao (phân bổ) (2)</th>
            <th class="border" colspan="${yearsHeader.length}">Năm</th>
          </tr>
          <tr>
            ${yearsHeaderHtml}
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">1</th>
            <th class="border">2</th>
            ${yearsIndexHtml}
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 25px;">
        <div>- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div style="margin-top: 5px;">- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="33%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="33%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="33%">
            <div style="font-style: italic; font-size: 11px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
